import { useEffect } from "react";
import { AdminApi } from "../api/admin.api";

const STORAGE_KEY = "feedback_read_count";

export function useFeedbackAlert() {
  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const res = await AdminApi.getData("feedback");
        const list = Array.isArray(res.data) ? res.data : [];
        const currentCount = list.length;

        const saved = Number(localStorage.getItem(STORAGE_KEY) || "0");

        // Первый запуск — просто запоминаем количество
        if (saved === 0) {
          localStorage.setItem(STORAGE_KEY, String(currentCount));
          return;
        }

        // Если появилось хотя бы одно новое сообщение
        if (currentCount > saved) {
          alert("Вам пришло новое обращение, прочитайте его");

          // После нажатия OK — обновляем сохранённое значение
          localStorage.setItem(STORAGE_KEY, String(currentCount));
        }

      } catch (e) {
        console.error("Ошибка проверки новых сообщений:", e);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);
}
